import AxiosConfig from '../config/axiosConfigApiAgenda'

export const TarefasApi = {

  async delete(id) {
    let response = await AxiosConfig.api().post(`tarefa/deletar`, {id})
    return response.data
  },

  async deleteTaskList(tarefas_ids, cronogramas_ids) {
    let response = await AxiosConfig.api().post(`tarefa/deletar/lista`, {
      tarefas_ids,
      cronogramas_ids
    })
    return response.data
  },

  async completeOrResetTask(id, completed) {
    let response = await AxiosConfig.api().post(`tarefa/completar`, {
      id,
      completed,
    })
    return response.data
  },

  async completeOrResetTaskList(tarefas_ids, completed) {
    let response = await AxiosConfig.api().post(`tarefa/completar/lista`, {
      tarefas_ids,
      completed,
    })
    return response.data
  },

  async updateEventDay(eventDay) {
    let response = await AxiosConfig.api().patch(`evento`, eventDay)
    return response.data
  }
}

export default TarefasApi
